import React from 'react';
import ShapesStarSquareIcon from './ShapesStarSquareIcon';

// Tracé FA Pro "fa-pen" (pro-duotone-svg-icons, faPen.icon) recopié tel
// quel — comme les tracés de ShapesStarIcon — plutôt qu'un dessin maison
// (rejeté visuellement) ou DuotoneLightIcon name='pen' (le kit FontAwesome
// chargé ici ne semble pas le résoudre : rendu observé avec ses propres
// teintes par défaut, ignorant --fa-primary-color/--fa-secondary-color,
// impossible à garantir identique à ShapesStarSquareIcon). PEN_PRIMARY = la
// pointe, PEN_SECONDARY = le corps — même découpage que le duotone FA
// d'origine, viewBox native 512x512.
const PEN_PRIMARY = 'M362.7 19.3c25-25 65.5-25 90.5 0l39.4 39.4c25 25 25 65.5 0 90.5L433 209 303 79l59.7-59.7z';
const PEN_SECONDARY = 'M433 209L303 79 52.8 329.3c-6.6 6.6-11.5 14.8-14.1 23.8L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l128.2-37.7c9-2.6 17.2-7.5 23.8-14.1L433 209z';

// Vrai rendu duotone FontAwesome : deux calques PLEINS (pas de contour), le
// primaire à pleine opacité, le secondaire à `secondaryOpacity` — la même
// mécanique que ShapesStarSquareIcon (même `color`/`secondaryOpacity`
// passés par ShapesStarEditIcon), pour des couleurs garanties identiques
// entre les deux icônes.
// Le tracé natif de fa-pen est incliné à ~42° de la verticale (pointe en
// bas-gauche, capuchon en haut-droit) : redressé partiellement ici (rotation
// interne, autour du centre du viewBox) pour garder une légère inclinaison
// plutôt que la diagonale prononcée d'origine ou un aplomb parfaitement
// vertical.
// PEN_SCALE : une fois tourné, le tracé (long et fin en diagonale dans son
// viewBox 512x512 d'origine) déborde de ce même viewBox en haut et en bas —
// mesuré (cf. bounding box tourné) à ~641 de haut pour un cadre de 512, d'où
// la pointe et le capuchon rognés sans ce correctif. Réduit d'autant avant
// rotation, autour du même centre, pour que la silhouette entière reste dans
// le cadre.
const PEN_ROTATION = -25;
const PEN_SCALE = 0.65;
const PenIcon = ({ style = {}, secondaryOpacity = 0.4 }) => {
  const { color = 'currentColor', ...rest } = style;

  return (
    <svg
      viewBox='0 0 512 512'
      width='1em'
      height='1em'
      style={rest}
      aria-hidden='true'
      focusable='false'
    >
      <g transform={`translate(256 256) scale(${PEN_SCALE}) rotate(${PEN_ROTATION}) translate(-256 -256)`}>
        <path d={PEN_PRIMARY} fill={color} />
        <path d={PEN_SECONDARY} fill={color} fillOpacity={secondaryOpacity} />
      </g>
    </svg>
  );
};

// Composition façon FontAwesome "layers" : étoile + carré empilés
// (ShapesStarSquareIcon) à gauche, crayon légèrement incliné à droite, sur
// la même hauteur (1em) — pour distinguer le bouton qui rejoint l'éditeur plein
// écran d'une forme composée ("Éditer en grand") du simple insert de forme
// (ShapesStarIcon seule, cf. BoxButtonsWrapper). Le kit FontAwesome installé
// ici n'expose pas FontAwesomeLayers (react-fontawesome 0.2.0 n'exporte que
// FontAwesomeIcon) : la couche est donc positionnée à la main.
// Largeur totale du conteneur (1.45em) calée sur le crayon redressé : sa
// silhouette verticale n'occupe qu'une bande étroite au centre de son
// carré de rendu (1em de large) — le placer à droite (`right: 0`) laisse
// ses marges transparentes chevaucher celles de l'étoile/carré (large de
// 0.75em) sans jamais toucher leurs tracés, pas de calcul de largeur exacte
// nécessaire.
// Couleurs en duotone : même `color` et même `secondaryOpacity` passées aux
// deux icônes (cf. PenIcon et ShapesStarSquareIcon) — garantit qu'elles
// restent au même ton, sans dépendre du rendu du kit FontAwesome pour la
// cohérence.
const ShapesStarEditIcon = ({ style = {}, secondaryOpacity = 0.4 }) => {
  const { fontSize = 20, color = 'currentColor' } = style;

  return (
    <span style={{ position: 'relative', display: 'inline-flex', width: fontSize * 1.45, height: fontSize }}>
      <ShapesStarSquareIcon style={{ fontSize, color }} secondaryOpacity={secondaryOpacity} />
      <PenIcon
        secondaryOpacity={secondaryOpacity}
        style={{ position: 'absolute', right: 0, top: 0, fontSize, color }}
      />
    </span>
  );
};

export default ShapesStarEditIcon;
